import { createSelector } from 'reselect'
import mapValues from 'lodash/mapValues'
import { Dictionary } from '@homebot/shared-util-quartermaster'
import { Home, Loan, Valuation } from '@homebot/shared-util-quartermaster/types'
import {
  selectCurrentCELs as selectCurrentCELLoans,
  selectHighestRateLoan,
  getConsolidatedBulkPaymentOnLoan,
} from './loans'

// TODO: TS state interface
type State = any

const getHomeData = (state: State) => state.home.data

const dictionary = Dictionary()

const mergeLoans =
  (fn: any): any =>
  (state: State) => ({
    ...getHomeData(state),
    loans: fn(state),
  })

export const bindDictionary = (home: Home) =>
  mapValues(dictionary, (f: any) => (...args: any) => {
    if (home) return f.call(dictionary, home, ...args)
    return undefined
  })

export const selectCurrentCELs: (state: any) => any = createSelector(
  mergeLoans(selectCurrentCELLoans),
  bindDictionary
)

export const selectFromCurrentCELs: (state: State) => any =
  (attr: any) => (state: State) =>
    selectCurrentCELs(state)[attr]()

export const selectAll: (state: State) => any = createSelector(
  getHomeData,
  bindDictionary
)

export const selectFromAll = (attr: string) => (state: State) =>
  selectAll(state)[attr]()

export const selectHighestRateLoanDictionary = createSelector(
  mergeLoans((state: State) => [selectHighestRateLoan(state)]),
  bindDictionary
)

export const selectExtraPaymentSavingsCalculator = createSelector(
  selectCurrentCELs,
  dictionary => (amt: number) =>
    dictionary.loans().reduce((sum: number, loan: Loan) => {
      const savings =
        dictionary.extraPaymentSavingsTotal({
          amt,
          diff: [getConsolidatedBulkPaymentOnLoan(loan)],
        }) || 0
      return sum + savings
    }, 0)
)

export const selectExtraPaymentSavedYearsCalculator = createSelector(
  selectCurrentCELs,
  dictionary => {
    const diff = dictionary
      .loans()
      .map((loan: Loan) => getConsolidatedBulkPaymentOnLoan(loan))
    return (amt: number) => dictionary.extraPaymentYears({ amt, diff })
  }
)

export const selectAvmWithoutCMA = createSelector(getHomeData, home =>
  home ? dictionary.avmObjectWithoutCMA(home) : undefined
)

export const sortMostRecentAVMs = (avms: Valuation[]) =>
  dictionary.sortMostRecentAVMs(avms)
